/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Helpful_Steep_Moth_AttendInputs */

const fr_helpful_steep_moth_attend = /** @type {(inputs: Helpful_Steep_Moth_AttendInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Feedback des utilisateurs`)
};

/**

* @param {Helpful_Steep_Moth_AttendInputs} inputs
* @param {{ locale?: "fr" }} options
* @returns {LocalizedString}
*/
export const helpful_steep_moth_attend = /** @type {((inputs?: Helpful_Steep_Moth_AttendInputs, options?: { locale?: "fr" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Helpful_Steep_Moth_AttendInputs, { locale?: "fr" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return fr_helpful_steep_moth_attend(inputs)
});